import type { Announcement } from '@stw/types';

import { stwFetch } from '@/utils/stwFetch';

/**
 * Get active announcements (public endpoint)
 */
export const getActiveAnnouncements = async (): Promise<Announcement[]> => {
  const response = await stwFetch('GET', '/announcements');
  // Handle both direct array response and {data: array} response
  return Array.isArray(response) ? response : response.data;
};
